module.exports = __webpack_public_path__ + "static/media/poppins-black.759f137c.woff";